<template>
  <div>
    <div class="interaction-editor pt-2" style="overflow-x: hidden;" v-if="can.editEmployerInteraction || can.editParticipantInteraction">
      <interaction :key="type" :type="type" :employerId="employerId" :participantId="participantId"></interaction>

      <div v-if="!participantId && !employerId" style="text-align: center;">
        To create an interaction<br/> open a participant or employer
      </div>
    </div>

  </div>
</template>

<script>
import Interaction from "./Interaction.vue";

export default {
  components: { Interaction },
  computed: {
    employerId() {
      return this.$route.params.employerId;
    },
    participantId() {
      return this.$route.params.participantId;
    },
    type: function() {
      return this.participantId ? 'Employee' : this.employerId && this.can.editEmployerInteraction ? 'Employer' : null;
    }
  }
};
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
textarea {
  width: 70%;
  min-width: 0px !important;
}

.invalid {
  border-color: #f04124 !important;
  color: #f04124 !important;
  font-size: 80%;
}
</style>



// WEBPACK FOOTER //
// src/interactions/InteractionEditor.vue